import {
    CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_ERROR,
    CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_IN_PROGRESS,
    CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_SUCCESS,
    CHANNEL_MIGRATION_DIALOG_HIDE,
    CHANNEL_MIGRATION_DIALOG_SHOW,
    FETCH_CHANNEL_MIGRATION_ERROR,
    FETCH_CHANNEL_MIGRATION_IN_PROGRESS,
    FETCH_CHANNEL_MIGRATION_STATUS_ERROR,
    FETCH_CHANNEL_MIGRATION_STATUS_IN_PROGRESS,
    FETCH_CHANNEL_MIGRATION_STATUS_SUCCESS,
    FETCH_CHANNEL_MIGRATION_SUCCESS,
    FETCH_RETRY_CHANNEL_MIGRATION_ERROR,
    FETCH_RETRY_CHANNEL_MIGRATION_IN_PROGRESS,
    FETCH_RETRY_CHANNEL_MIGRATION_SUCCESS,
} from '../../constants/channelMigration';
import Axios from 'axios';
import { handleErrorMessage } from '../../utils/errorMessages';
import {
    CHANNEL_MIGRATION_AUTHZ_ADDRESS_URL,
    urlChannelMigration,
    urlChannelMigrationStatus,
    urlRetryChannelMigration,
} from '../../constants/restURL';

export const showChannelMigrationDialog = (value) => {
    return {
        type: CHANNEL_MIGRATION_DIALOG_SHOW,
        value,
    };
};

export const hideChannelMigrationDialog = () => {
    return {
        type: CHANNEL_MIGRATION_DIALOG_HIDE,
    };
};

const fetchChannelMigrationInProgress = () => {
    return {
        type: FETCH_CHANNEL_MIGRATION_IN_PROGRESS,
    };
};

const fetchChannelMigrationSuccess = (value) => {
    return {
        type: FETCH_CHANNEL_MIGRATION_SUCCESS,
        value,
    };
};

const fetchChannelMigrationError = (message) => {
    return {
        type: FETCH_CHANNEL_MIGRATION_ERROR,
        message,
    };
};

export const fetchChannelMigration = (id, data, cb) => (dispatch) => {
    dispatch(fetchChannelMigrationInProgress());

    const URL = urlChannelMigration(id);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelMigrationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelMigrationError(message));
            const errorData = error?.response?.data;
            if (cb) {
                cb(errorData);
            }
        });
};

const fetchChannelMigrationStatusInProgress = () => {
    return {
        type: FETCH_CHANNEL_MIGRATION_STATUS_IN_PROGRESS,
    };
};

const fetchChannelMigrationStatusSuccess = (value) => {
    return {
        type: FETCH_CHANNEL_MIGRATION_STATUS_SUCCESS,
        value,
    };
};

const fetchChannelMigrationStatusError = (message) => {
    return {
        type: FETCH_CHANNEL_MIGRATION_STATUS_ERROR,
        message,
    };
};

export const fetchChannelMigrationStatus = (id, cb) => (dispatch) => {
    dispatch(fetchChannelMigrationStatusInProgress());

    const URL = urlChannelMigrationStatus(id);
    Axios.get(URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelMigrationStatusSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelMigrationStatusError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const channelMigrationAuthzAccountAddressInProgress = () => {
    return {
        type: CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_IN_PROGRESS,
    };
};

export const channelMigrationAuthzAccountAddressSuccess = (value, message) => {
    return {
        type: CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

export const channelMigrationAuthzAccountAddressError = (message) => {
    return {
        type: CHANNEL_MIGRATION_AUTHZ_ADDRESS_FETCH_ERROR,
        message,
    };
};

export const fetchChannelMigrationAuthzAccountAddress = () => (dispatch) => {
    dispatch(channelMigrationAuthzAccountAddressInProgress());

    Axios.get(CHANNEL_MIGRATION_AUTHZ_ADDRESS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(channelMigrationAuthzAccountAddressSuccess(res.data && res.data.result, 'Success'));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(channelMigrationAuthzAccountAddressError(message));
        });
};

const fetchRetryChannelMigrationInProgress = () => {
    return {
        type: FETCH_RETRY_CHANNEL_MIGRATION_IN_PROGRESS,
    };
};

const fetchRetryChannelMigrationSuccess = (value) => {
    return {
        type: FETCH_RETRY_CHANNEL_MIGRATION_SUCCESS,
        value,
    };
};

const fetchRetryChannelMigrationError = (message) => {
    return {
        type: FETCH_RETRY_CHANNEL_MIGRATION_ERROR,
        message,
    };
};

export const fetchRetryChannelMigration = (id, data, cb) => (dispatch) => {
    dispatch(fetchRetryChannelMigrationInProgress());

    const URL = urlRetryChannelMigration(id);
    Axios.post(URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchRetryChannelMigrationSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchRetryChannelMigrationError(message));
            const errorData = error?.response?.data;
            if (cb) {
                cb(errorData);
            }
        });
};
